import firebase from "firebase/app";
import Vue from "vue";
import { userLogger } from "@/utils/userLogger";
//import "firebase/firestore";

/**
 * Removes undefined fields from an object before saving to Firestore.
 * Firestore does not accept undefined values.
 */
function removeUndefinedFields(obj) {
  const cleaned = {};
  for (const key in obj) {
    if (obj[key] !== undefined) {
      cleaned[key] = obj[key];
    }
  }
  return cleaned;
}

export const state = {
  venue: null,
  venues: [],
  festivalVenues: []
};

export const mutations = {
  SET_VENUE(state, venue) {
    state.venue = venue;
  },
  SET_VENUES(state, venues) {
    console.log("venues", venues);
    state.venues = venues;
  },
  SET_FESTIVAL_VENUES(state, venues) {
    console.log("setting festival venues", venues);
    state.festivalVenues = venues;
  },
  ADD_FESTIVAL_VENUE(state, venue) {
    console.log("adding festival venue", venue);
    state.festivalVenues.push(venue);
  },
  ADD_NEW_VENUE_PROFILE(state, venue) {
    state.venues.push(venue);
  },
  ADD_VENUE_PROFILE(state, venue) {
    console.log("adding venue profile");
    if (
      state.venues &&
      state.venues.length > 0 &&
      state.venues[state.venues.length - 1].name == ""
    )
      Vue.set(state.venues, state.venues.length - 1, venue);
    else state.venues.push(venue);
  },
  UPDATE_VENUE_CAPACITY(state, venue) {
    const newvenues = state.festivalVenues;
    console.log("Updating venue cap", venue);
    state.festivalVenues = newvenues;
  }
};

export const actions = {
  async fetchVenue({ commit }, venueId) {
    var db = firebase.firestore();
    var docRef = db.collection("venues").doc(venueId);
    var doc = await docRef.get();

    if (doc.exists) {
      commit("SET_VENUE", doc.data());
    } else {
      console.log("Could not find venue " + venueId);
    }
  },
  async fetchFestivalVenues({ commit }, venues) {
    console.log("Getting venues for festival season", venues);
    var db = firebase.firestore();
    var venuelist = [];
    for (const venue of venues) {
      console.log("getting venue by ID", venue);
      var docRef = db.collection("venues").doc(venue);
      var doc = await docRef.get();
      if (doc.exists) {
        venuelist.push(doc.data());
      } else {
        console.log("Could not find venue " + venue);
      }
    }
    commit("SET_FESTIVAL_VENUES", venuelist);
  },
  async fetchMyVenues({ commit }, userId) {
    console.log("fetching venues", userId);
    var db = firebase.firestore();
    var docRef = db.collection("venues").where("owners." + userId, "!=", "");
    var docs = await docRef.get();

    if (!docs.empty) {
      commit(
        "SET_VENUES",
        docs.docs.map(doc => doc.data())
      );
    } else {
      console.log("Could not find venues.");
    }
  },
  async setVenue({ commit }, venue) {
    var db = firebase.firestore();
    const cleanedVenue = removeUndefinedFields(venue);

    // Does the venue exist already?
    const doc = await db
      .collection("venues")
      .doc(venue.id)
      .get();
    if (doc.exists) {
      // Update existing venue with cleaned data
      console.log("Updating existing venue", cleanedVenue);
      await db
        .collection("venues")
        .doc(venue.id)
        .update(cleanedVenue)
        .catch(function(error) {
          console.error("Error updating venue: ", error);
        });
      commit("SET_VENUE", cleanedVenue);
    }
    // Apparently not. Add it.
    else {
      await db
        .collection("venues")
        .doc(venue.id)
        .set(cleanedVenue)
        .catch(function(error) {
          console.error("Error updating venue: ", error);
        });

      console.log("Venue Recieved", cleanedVenue);
      commit("SET_VENUE", cleanedVenue);
    }
  },
  async addFestivalVenue({ commit }, venue) {
    const newvenue = await ensureVenue(venue);
    console.log("Venue Recieved", venue);
    commit("ADD_FESTIVAL_VENUE", newvenue);
    return newvenue.id;
  },
  addNewVenueProfile({ commit }) {
    commit("ADD_NEW_VENUE_PROFILE", { name: "", tax: "remit" });
  },
  async addVenueProfile({ commit }, venue) {
    var db = firebase.firestore();
    const cleanedVenue = removeUndefinedFields(venue);
    // Get the doc ref
    const venueRef = await db.collection("venues").doc(venue.id);

    // Does the venue exist already?
    const doc = await venueRef.get();
    if (doc.exists) {
      var venueData = doc.data();
      // Has it been claimed?
      if (venueData.owners)
        commit("ADD_VENUE_PROFILE", {
          id: venue.id,
          name: venue.name,
          error: "Venue already cliamed by another Gobo user."
        });
      else {
        await venueRef.update({ owner: venue.owner, owners: venue.owners });
        const claimedVenue = (await venueRef.get()).data();
        commit("ADD_VENUE_PROFILE", claimedVenue);

        // Log venue claiming
        if (venue.owner) {
          await userLogger.logActivity(venue.owner, "venue_claimed", {
            venueId: venue.id,
            venueName: venue.name
          });
        }
      }
    } else {
      await db
        .collection("venues")
        .doc(venue.id)
        .set(cleanedVenue)
        .catch(function(error) {
          console.error("Error updating venue: ", error);
        });

      console.log("Venue Added & Claimed", cleanedVenue);
      commit("ADD_VENUE_PROFILE", cleanedVenue);

      // Log venue creation
      if (venue.owner) {
        await userLogger.logVenueCreated(venue.owner, venue.id, venue.name);
      }
    }
  },
  saveVenueCapacity({ commit }, venue) {
    var db = firebase.firestore();
    db.collection("venues")
      .doc(venue.id)
      .update({ capacity: venue.capacity });
    commit("UPDATE_VENUE_CAPACITY", venue);
  },
  async saveVenueProfileImage({ commit }, venue) {
    console.log("saving a venue image");
    var db = firebase.firestore();
    var venueRef = await db.collection("venues").doc(venue.id);
    await venueRef
      .update({
        image: venue.image
      })
      .catch(function(error) {
        console.error("Error saving document: ", error);
      });

    var savedProfile = await venueRef.get();
    commit("SET_VENUE", savedProfile.data());
  },
  async clearVenue({ commit }) {
    commit("SET_VENUE", null);
  }
};

export const getters = {
  venue(state) {
    return state.venue;
  },
  venues(state) {
    return state.venues;
  },
  festivalVenues(state) {
    return state.festivalVenues;
  }
};

async function ensureVenue(venue) {
  var db = firebase.firestore();
  const cleanedVenue = removeUndefinedFields(venue);
  // Does the venue exist already?
  const doc = await db
    .collection("venues")
    .doc(venue.id)
    .get();
  if (doc.exists) return doc.data();
  // Apparently not. Add it.
  else {
    await db
      .collection("venues")
      .doc(venue.id)
      .set(cleanedVenue)
      .catch(function(error) {
        console.error("Error updating venue: ", error);
      });
    return cleanedVenue;
  }
}
